import { useServices } from "@/hooks/api/services/useServices";
import { Message, MessageType } from "@/models/Message";
import { makeStyles, Text, tokens } from "@fluentui/react-components";
import React from "react";

type Props = {
  message: Message;
  recipientChanged?: boolean;
};

export const UserMessageBubble: React.FC<Props> = ({ message, recipientChanged = false }) => {
  const { data: services } = useServices();
  const formattedDatetime = new Date(message.createdAt).toLocaleString();

  const classes = useStyles();
  if (message.type === MessageType.CHOICE) {
    return;
  }

  // 送信先が変更された場合、@メンションを表示する
  const mention = recipientChanged
    ? (
      <>
        <Text className={classes.mention}>@{services!.getById(message.recipient)?.name}</Text>
        <br />
      </>
    )
    : null;

  return (
    <div className={classes.wrapper}>
      <Text className={classes.datetime}>{formattedDatetime}</Text>
      <Text className={classes.message}>{mention}{message.content}</Text>
    </div>
  );
};

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "end",
    background: tokens.colorNeutralBackground1,
  },
  datetime: {
    fontSize: tokens.fontSizeBase200,
  },
  mention: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: 600,
    color: tokens.colorBrandForeground2,
  },
  message: {
    backgroundColor: tokens.colorBrandBackground2,
    fontSize: tokens.fontSizeBase300,
    borderRadius: "4px",
    padding: "12px 16px",
    width: "487px",
    whiteSpace: "pre-wrap",
  },
});
